const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export const CLOUDINARY_FOLDERS = {
    kakoos: 'kakoos',
    peircings: 'peircings',
    availablesketches: 'availablesketches',
    covers: 'covers',
    hair: 'hair',
};

export async function uploadImage(file, category) {
    console.log('Upload starting:', { file: file.name, category, CLOUD_NAME, UPLOAD_PRESET });
    
    if (!CLOUD_NAME || !UPLOAD_PRESET) {
        throw new Error(`Missing config: cloud_name=${CLOUD_NAME}, preset=${UPLOAD_PRESET}`);
    }

    const folder = CLOUDINARY_FOLDERS[category] || category;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UPLOAD_PRESET);
    formData.append('folder', folder);
    formData.append('context', `category=${category}`);

    const url = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;
    console.log('Uploading to:', url);

    const response = await fetch(url, {
        method: 'POST',
        body: formData,
    });

    const data = await response.json();
    console.log('Upload response:', data);

    if (!response.ok) {
        throw new Error(data.error?.message || 'Upload failed');
    }

    return {
        public_id: data.public_id,
        secure_url: data.secure_url,
        folder: data.folder || folder,
    };
}

export async function deleteImage(public_id) {
    return { success: true, public_id };
}

export function getCloudinaryUrl(publicId, transformations = '') {
    if (!publicId) return '';
    const baseUrl = `https://res.cloudinary.com/${CLOUD_NAME}/image/upload`;
    return transformations ? `${baseUrl}/${transformations}/${publicId}` : `${baseUrl}/${publicId}`;
}

export function getThumbnailUrl(secureUrl) {
    if (!secureUrl) return '';
    return secureUrl.replace('/upload/', '/upload/w_600,h_600,c_fill/');
}

export function getFullSizeUrl(secureUrl) {
    if (!secureUrl) return '';
    return secureUrl.replace('/upload/', '/upload/w_1200,h_1200,c_fill/');
}
